import React from 'react'
import { createEditable } from '../helpers'
import { appConverter } from '../helpers/converter'

export const withEditableConverter = <T, P>(
  Component: React.FunctionComponent,
  changePropertyName = 'onChangeText',
) => {
  const Input = createEditable({ Component, changePropertyName })

  return React.forwardRef((props: P, ref: React.Ref<T>) => (
    <Input converter={appConverter} {...props} ref={ref} />
  ))
}
